import { IconType } from "./icons.types";

export const ExportIcon = ({ className, color = "#000000" }: IconType) => {
  return (
    <svg
      className={className}
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 15C7.5 11 11.5 9 15.5 9M15.5 9L13.5 12M15.5 9L12.5 7M5.5 21H17.5C19.7091 21 21.5 19.2091 21.5 17V5C21.5 2.79086 19.7091 1 17.5 1H5.5C3.29086 1 1.5 2.79086 1.5 5V17C1.5 19.2091 3.29086 21 5.5 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
